module.exports = __webpack_public_path__ + "static/media/Aalidhra16a2.ba2b5cc6.jpg";